import HundredBricksAPIError from '../../../HundredBricksAPIError';
class BrickRecommendationsError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('BrickRecommendationsError', ...args);
    }
}
export default BrickRecommendationsError;
